module.exports = __webpack_public_path__ + "media/customizations/onvie/back-deb15fd00af654cb1a3f831d8457b09c.jpg";